document.addEventListener("DOMContentLoaded", () => {
    const rateButton = document.querySelector(".rate");
    const commentFormWrapper = document.querySelector(".commentFormWrapper");

    if (!rateButton || !commentFormWrapper) return;

    let isAnimating = false;

    // ResizeObserver zur Aktualisierung der Höhe
    const resizeObserver = new ResizeObserver((entries) => {
        if (!isAnimating) {
            entries.forEach((entry) => {
                const element = entry.target;
                if (commentFormWrapper.classList.contains("js-expanded")) {
                    gsap.set(commentFormWrapper, { height: element.scrollHeight });
                }
            });
        }
    });

    const toggleVisibility = () => {
        const innerContent = commentFormWrapper.firstElementChild;

        if (isAnimating) return;

        isAnimating = true;

        if (!commentFormWrapper.classList.contains("js-expanded")) {
            commentFormWrapper.classList.add("js-expanded");
            gsap.set(commentFormWrapper, { height: "auto" });
            gsap.fromTo(
                commentFormWrapper,
                { height: 0, autoAlpha: 0 },
                {
                    height: innerContent.scrollHeight,
                    autoAlpha: 1,
                    duration: 0.3,
                    ease: "sine.inOut",
                    onComplete: () => {
                        isAnimating = false;
                    },
                }
            );

            resizeObserver.observe(innerContent);
        } else {
            commentFormWrapper.classList.remove("js-expanded");
            gsap.to(commentFormWrapper, {
                height: 0,
                autoAlpha: 0,
                duration: 0.3,
                ease: "sine.inOut",
                onComplete: () => {
                    isAnimating = false;

                    resizeObserver.unobserve(innerContent);
                },
            });
        }
    };

    rateButton.addEventListener("click", toggleVisibility);

    if (window.location.hash === "#rating") {
        commentFormWrapper.classList.add("js-expanded");
        const innerContent = commentFormWrapper.firstElementChild;
        gsap.set(commentFormWrapper, { height: "auto", autoAlpha: 1 });
        resizeObserver.observe(innerContent);
    } else {
        gsap.set(commentFormWrapper, { height: 0, autoAlpha: 0 });
        commentFormWrapper.classList.remove("js-expanded");
    }
});
